module.exports = __webpack_public_path__ + "static/crab-lg-b0904fb7954a5d5cc26d2a6e4be0171b.jpg";